
import FtxToken from "../../../assets/outline/FtxToken.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FtxTokenIcon({ className, dataTestid = "FtxTokenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FtxToken data-testid={dataTestid} className={classes} {...rest} />
  );
}
